import React from 'react';

import Debug from '@/components/Debug';
import { ExternalVerificationState } from '@/types/externalVerification';
import { DataRow } from '@/ui/components/DataList';

import ExternalPolicyVerification from '../../ExternalPolicyVerification';

import { Props } from './types';

const VOBResponse = ({ responseErrorMessage, externalVerification }: Props) => {
  if (responseErrorMessage) {
    return (
      <>
        <DataRow label="Response">Failed</DataRow>
        <DataRow label="Message">{responseErrorMessage}</DataRow>
      </>
    );
  }
  if (!externalVerification) return null;
  if (
    externalVerification.state === ExternalVerificationState.SUCCESS &&
    externalVerification.policy_verifications[0]
  ) {
    return (
      <ExternalPolicyVerification
        externalPolicyVerification={externalVerification.policy_verifications[0]}
        debugObject={externalVerification}
      />
    );
  } else {
    return (
      <div className="relative">
        <DataRow label="Response">{externalVerification.state}</DataRow>
        {externalVerification.rejections?.map(({ id, description }) => (
          <p key={id}>{description}</p>
        ))}
        <Debug object={externalVerification} />
      </div>
    );
  }
};
export default React.memo(VOBResponse);
